import { Button } from "@/components/ui/button";
import { useDispatch } from "react-redux";
import { setSelectedApplicationId } from "@/features/leads/stores/leadFunctionalSlice";

export default function ActionForApplicationDetail() {
  const dispatch = useDispatch();

  const handleCancel = () => {
    dispatch(setSelectedApplicationId(null));
  };

  const handleUpdateChanges = () => {};

  return (
    <div className=" flex items-center justify-end">
      <div className="flex items-center gap-4">
        <Button variant="cancel" onClick={handleCancel}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleUpdateChanges}>
          Update Changes
        </Button>
      </div>
    </div>
  );
}
